import {trackOnce} from 'od-modules/track_events/track.frontevents.utils';

export const NAG_SCOPE = 'NAGS';

const createNagValues = (product) => [
    `${NAG_SCOPE}:${product}:APPEARANCE`,
    `${NAG_SCOPE}:${product}:ACCEPTANCE`,
    `${NAG_SCOPE}:${product}:REJECTION`,
];

const nagValues = [
    'SO_REJECT',
    'INSURANCE_REJECT',
    'ANCILLARIES_STEP',
    'NO_INSURANCE_SELECTED',
    'FLEX_NAG',
    'DEFAULT_BAGGAGE',
    'BAGGAGE_EXTEND',
    'REMOVED_BAGGAGE',
    'NO_SEATS_SELECTED',
    'SEATS_SUBMIT',
    'HOTELS_REMINDER',
    'BAGGAGE_XFARING_EXTEND',
    'PRIME_USER_BLOCKED',
].flatMap(createNagValues);

export const trackNag = (type) => {
    const $nagContainer = $('#nag_container');
    $nagContainer.attr('data-id', `${NAG_SCOPE}:${type}:APPEARANCE`);
    $('.nag_btn_action').attr('data-id', `${NAG_SCOPE}:${type}:ACCEPTANCE`);
    $('.nag_btn_ignore').attr('data-id', `${NAG_SCOPE}:${type}:REJECTION`);
    trackOnce($nagContainer);
};

export default new Set(nagValues);
